<ion-card>
  <ion-card-header>
    <ion-toolbar>

      <ion-icon slot="start" size="large" [src]="TP_SECTIONS_INFO['icd9'].icon | getIcon"></ion-icon>

      <ion-title>{{TP_SECTIONS_INFO['icd9'].label}}</ion-title>
    </ion-toolbar>

  </ion-card-header>

  <ion-card-content>
    <div *ngIf="loading$ | async">
      <ion-grid>
        <ion-row class="ion-align-items-center">
          <ion-col size="12" class="c3-flex ion-justify-content-center ion-align-items-center">
            <ion-spinner color="secondary"></ion-spinner>
          </ion-col>
          <ion-col size="12" class="ion-text-center">
            <span>Caricamento in corso...</span>
          </ion-col>
        </ion-row>
      </ion-grid>
    </div>
    <div config-description *ngIf="!(loading$ | async)">
      <p>{{TP_SECTIONS_INFO['icd9'].description}}</p>
      <div class="app-margin-divider"></div>
      <ag-grid-angular c3DarkTable class="c3-table-with-clickable-rows"
                       *ngIf="columnDefs &&(icd9PatientList$| async)?.length > 0" [rowData]="icd9PatientList$ | async"
                       [columnDefs]="columnDefs" [gridOptions]="customAgGridOptions">
      </ag-grid-angular>

      <ion-grid *ngIf="(icd9PatientList$ | async)?.length === 0">
        <ion-row>
          <ion-col size="auto">

            <app-hint-msg size="small">
              Nessun codice ICD-9 associato al paziente.
            </app-hint-msg>

          </ion-col>
        </ion-row>
      </ion-grid>
    </div>
  </ion-card-content>
</ion-card>

<ng-template #actionsCellTmpl let-data>
  <ion-buttons>
    <ion-button *ngIf="contextInfo?.[data?.data?.context]?.current" (click)="openEditDialog(data?.data)"
                c3Tooltip="Modifica/Aggiungi">
      <ion-icon slot="icon-only" color="primary" [src]="'pencil' | getIcon"></ion-icon>
    </ion-button>
  </ion-buttons>
</ng-template>